import { IOrderDeliveryTask, IPickupTask } from "../../../interfaces/delivery-company/tasks";


export interface OrderedTask {
    type: "pickup" | "delivery";
    val: IPickupTask | IOrderDeliveryTask
}

export const getSortedTasks = (pickupTasks?: IPickupTask[], deliveryTasks?: IOrderDeliveryTask[]): OrderedTask[] => {
    const mutated_pickups: OrderedTask[] = pickupTasks ? pickupTasks.map(item => { return { type: "pickup", val: item } }) : []
    const mutated_deliveries: OrderedTask[] = deliveryTasks ? deliveryTasks.map(item => { return { type: "delivery", val: item } }) : []

    return [...mutated_pickups, ...mutated_deliveries].sort((task_a, task_b) => {
        const date_a = new Date(task_a.val.creation_date ?? "")
        const date_b = new Date(task_b.val.creation_date ?? "")
        return date_b.getTime() - date_a.getTime()
    })
}